module.exports = __webpack_public_path__ + "static/media/About.cb233101.svg";